import { UpdateCompanyCustomerModel, UpdateModel } from "@/models/Member";

class UpdateModelHelper {
    static createUpdateCompanyCustomerModel(selectedCustomer: any ): UpdateCompanyCustomerModel {
      const updateModel: UpdateCompanyCustomerModel = {
        externalId: selectedCustomer.externalId || '',
        name: selectedCustomer.firstName || '',
        lastName: selectedCustomer.lastName || '',
        email: selectedCustomer.email || '',
        mobilePhone: selectedCustomer.mobilePhone || '',
        line1: '',
        zip: '',
        city: '',
        orderInformation: selectedCustomer.orderInformation || '',
        country: "Sweden"
      };

      if (selectedCustomer.deliveryAddresses && selectedCustomer.deliveryAddresses.length > 0) {
          updateModel.line1 = selectedCustomer.deliveryAddresses[0].line1 || '';
          updateModel.zip = selectedCustomer.deliveryAddresses[0].zip || '';
          updateModel.city = selectedCustomer.deliveryAddresses[0].city || '';
      }
      else {
        updateModel.line1 = selectedCustomer.line1;
        updateModel.zip = selectedCustomer.zip;
        updateModel.city = selectedCustomer.city;

      }

      return updateModel;
    }
    static createUpdateModel(customer: any): UpdateModel {
      let addressInfo = customer.deliveryAddresses?.length > 0 ? customer.deliveryAddresses[0] : customer.invoiceAddress;
      //Should probably make a proper fix for updating avtalskund
      if(customer.company?.companyType === 'Avtal') {
        addressInfo = customer.company.invoiceAddress
      }


      return {
          addressId: addressInfo.id,
          line1: addressInfo.line1,
          zip: addressInfo.zip,
          city: addressInfo.city,
          country: addressInfo.country,
          mobilePhone: customer.mobilePhone,
          orderInformation: customer.orderInformation
        };
      }
  }
  
  export default UpdateModelHelper;